import moment from "moment";
import {
  IAppointment,
  IAppointmentRoutingTalkdeskDC,
  IScheduleAppointmentRequest,
} from "../../models/schedule/IAppointment";
import {
  IScheduleRequest,
  IScheduleSecurity,
  IScheduleResponse,
} from "../../models/schedule/ISchedule";
import { IScheduleService } from "../../models/schedule/IScheduleService";
import { AppConfigService as Config } from "../app.config.service";
import ky from "ky";

export class TalkdeskAppointmentService implements IScheduleService {
  async create(
    request: IScheduleRequest,
    security: IScheduleSecurity
  ): Promise<IScheduleResponse> {
    try {
      const routing: IAppointmentRoutingTalkdeskDC = {
        type: "TALKDESK_DIGITAL_CONNECT",
        properties: {
          chatMode: Config.chatMode,
          touchpointId: Config.dcTouchpointId,
        },
      };

      const schedule: IScheduleAppointmentRequest = {
        ...request,
        interaction: {
          routing,
        },
        customer: {
          ...request.customer,
          contact: {
            ...request.customer.contact,
            primaryPhone:
              request.customer.contact.primaryPhoneCountryCode +
              request.customer.contact.primaryPhone.trim(),
          },
        },
        metadata: {
          ...request.metadata,
          ...request.customer.metadata,
        },
        notificationHeaders: Config.appointmentNotificationHeaders,
        applicationId: Config.applicationId,
        timezone: Config.schedule.timeZone,
        duration: moment
          .duration(Config.scheduleIntervalMinutes, "minutes")
          .toISOString(),
        locale: Config.locale,
      };

      const basicToken = btoa(
        [
          request.customer.contact.primaryPhoneCountryCode +
            request.customer.contact.primaryPhone.trim(),
          security.verificationCode,
          security.otp,
        ].join(":")
      );

      const response = await ky
        .post(`${Config.auviousBaseUrl}/api/appointments/basic`, {
          json: schedule,
          headers: {
            Authorization: `Basic ${basicToken}`,
          },
        })
        .json<IAppointment<IAppointmentRoutingTalkdeskDC>>();

      return { scheduleEntityId: response.id, request };
    } catch (ex) {
      throw ex;
    }
  }
}
